import { faBoxOpen, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@shared/components/ui/button';
import React from 'react';
import { Badge } from '../../../../shared/components/ui';

interface FloatingActionsProps {
  selectedCount: number;
  totalCount: number;
  onSendToPreparation: () => void;
  onClearSelection: () => void;
}

export const FloatingActions: React.FC<FloatingActionsProps> = ({
  selectedCount,
  totalCount,
  onSendToPreparation,
  onClearSelection,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-card rounded-lg shadow-lg border border-border p-2 flex items-center gap-2">
        {/* Información de selección */}
        <div className="flex items-center gap-2">
          <Badge variant="outline">
            <span className="">{selectedCount}</span>
          </Badge>
          <div className="text-sm">
            <span className="font-medium">seleccionados</span>
          </div>
        </div>

        {/* Acciones */}
        <div className="flex items-center gap-2">
          {/* Botón de limpiar selección */}
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            className="text-muted-foreground hover:text-foreground h-8 w-8 p-0"
            title="Limpiar selección"
          >
            <FontAwesomeIcon icon={faTimes} className="w-4 h-4" />
          </Button>

          {/* Botón principal de acción */}
          <Button onClick={onSendToPreparation} variant="primary" size="sm">
            <FontAwesomeIcon icon={faBoxOpen} className="mr-2 w-4 h-4" />
            Preparar
          </Button>
        </div>
      </div>
    </div>
  );
};
